import {
  v4 as uuidv4
} from 'uuid';

// 32 length hex
const uuidHex = () => {
  return uuidv4().replaceAll('-', '');
};

export {
  uuidHex,
};
